import { Component } from '@angular/core';

@Component({
    selector: 'app-contacto',
    templateUrl: './contacto.component.html',
    styleUrls: ['./contacto.component.scss'],
    standalone: false
})
export class ContactoComponent {
}
